// extracted by mini-css-extract-plugin
module.exports = {"input":"form_styles_input__2fPve"};